// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
// FeedbackType is the type of feedback.
export var FeedbackType;
(function (FeedbackType) {
    FeedbackType["FEEDBACK_TYPE_UNSPECIFIED"] = "FEEDBACK_TYPE_UNSPECIFIED";
    FeedbackType["FEEDBACK_TYPE_GOOD"] = "FEEDBACK_TYPE_GOOD";
    FeedbackType["FEEDBACK_TYPE_BAD"] = "FEEDBACK_TYPE_BAD";
})(FeedbackType || (FeedbackType = {}));
export var FeedbackType_index;
(function (FeedbackType_index) {
    FeedbackType_index[FeedbackType_index["FEEDBACK_TYPE_UNSPECIFIED"] = 0] = "FEEDBACK_TYPE_UNSPECIFIED";
    FeedbackType_index[FeedbackType_index["FEEDBACK_TYPE_GOOD"] = 1] = "FEEDBACK_TYPE_GOOD";
    FeedbackType_index[FeedbackType_index["FEEDBACK_TYPE_BAD"] = 2] = "FEEDBACK_TYPE_BAD";
})(FeedbackType_index || (FeedbackType_index = {}));
// OfficeAssistant is used for managing smart tags and classification of entities.
export const OfficeAssistant = {
    // SubmitTagSuggestionFeedback
    SubmitTagSuggestionFeedback(fn, req) {
        try {
            fm.validateUrlParam(req["smartTagId"], "smartTagId");
            fm.validateUrlParam(req["entityType"], "entityType");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/office-assistant/v1/feedback/${req["smartTagId"]}/${req["entityType"]}`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
